import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FeedbackDetailAPICallProps } from "../../type";
import { deleteApi } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export const deleteDraftData = createAsyncThunk(
  "feedback/shared/draft/delete",
  async (params: FeedbackDetailAPICallProps, storeActions) => {
    const url = `api/v1/user/feedbacks/draft/delete?feedbackId=${params.feedbackId}`;
    const response: any = await deleteApi(url, storeActions);

    if (response.status === HttpStatus.OK) {
      return {
        status: HttpStatus.OK,
        data: await response.json(),
      };
    } else {
      return {
        status: response.status,
        text: await response.text(),
      };
    }
  }
);

const sharedDraftDeleteDataSlice = createSlice({
  name: "sharedDraftDeleteData",
  initialState: {
    status: null as number | null,
    loading: false as boolean,
    text: null as string | null,
    data: null as number | null,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.text = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(deleteDraftData.fulfilled, (state, action) => {
      state.status = action.payload.status;
      state.loading = false;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.text = null;
      } else if (action.payload.text !== undefined) {
        state.data = null;
        state.text = action.payload.text;
      }
    });
    builder.addCase(deleteDraftData.pending, (state) => {
      state.status = null;
      state.loading = true;
      state.data = null;
      state.text = null;
    });
    builder.addCase(deleteDraftData.rejected, (state) => {
      state.status = 503;
      state.loading = false;
      state.data = null;
      state.text = null;
    });
  },
});

export const { clearData } = sharedDraftDeleteDataSlice.actions;

export default sharedDraftDeleteDataSlice;
